import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import Select from "../../../Components/select/select";
import TextField from "../../../Components/textField/textField";
import TableEditable from "../../../Components/tableEditable/TableEditable";
import moment from 'moment';
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";

export default class alter_op extends React.Component {
  state = {
    PO_code_array: [],
    selected_Machine: null,
    id: 0,
    code: "",
    piece_code: "",
    id_machine: null,
    machines: [],
    machinesAllProps: [],
    piece_production: "",
    show: false,
    message: "",
    items: [],
    units: [{value: "peca", label: "Peça"},{value: "metroLinear", label: "Metro Linear"}],
    selectedUnit: "",
    operations: [],
    selectedItem: "",
    render: false,
    operationsAllprops: [],
    objEdit: { operation: "", alternative:"", pph: "", piece_cicle: "", time_wait_piece_cicle: "", machine: 0 },
    count: 0,
    selected_MachineOp: "",
    id_item: 0,
    readOnly: true,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };

  async componentDidMount() {

    await Api.get("/machines/").then((resp) => {
      let arr = [];

      resp.data.forEach((element) => {
        arr.push({
          value: element.id,
          label: element.description + element.code,
        });
      });

      this.setState({ machines: arr, machinesAllProps: [...resp.data] });
    });

    Api.get("/production-orders-web/")
      .then((resp) => {
        let arr_codes = [];
        let arr_ids = [];
        resp.data.response.forEach((element) => {
          arr_codes.push({ value: element.id, label: element.code });
          arr_ids.push({ id: element.id, code: element.code });
        });
        this.setState({ PO_code_array: arr_codes },()=>{
          if(this.state.machinesAllProps.length === 0){
            Api.get("/machines/").then((re) => {
              let arr2 = [];
        
              re.data.forEach((el) => {
                arr2.push({
                  value: el.id,
                  label: el.description + el.code,
                });
              });
        
              this.setState({ machines: arr2, machinesAllProps: [...re.data] });
            });
          }
        });
      })
      .catch((error) => {
        if (error.response) {
          alert(
            error.response.data +
            "\n" +
            error.response.status +
            "\n" +
            error.response.headers
          );
        }
      });

    

    Api.get("/items/").then((resp) => {
      let arr = []
      resp.data.forEach((element) => {
        arr.push({ value: element.id, label: element.code + ' - ' + element.description })
      })
      this.setState({ items: arr })
    });
  }

  componentDidUpdate(prevProps) {
    if (this.state.operations !== prevProps.operations) {
      if (this.state.operations.length > 0 && !this.state.render) {
        this.setState({ render: true })
      }
    }
  }
  setOperations = (event) => {
    let auxarr = []
    let counter = 0
    event.forEach(e => {
      auxarr.push({
        operation: e["Código"], alternative: e.Alternativa,
        pph: e.PPH, piece_cicle: e['Nº Peça/Ciclo'],
        time_wait_piece_cicle: e['Tempo de espera'],
        machine: e['Máquina']
      })
      counter++
      if (counter === event.length) {
        this.setState({ operationsAllprops: [...auxarr], operations: event }, () => {
        })
      }
    })
  }

  setOperation = (value, name) => {
    if(typeof name != "undefined"){
      let obj = this.state.objEdit
      obj[name] = value
      this.setState({ objEdit: obj })
    }
    
  }
  selectPoCode = (childData) => {
    Api.get(`/production-orders-id/${childData}`).then((resp) => {
      const {
        order,
        piece_code,
        date_created,
        piece_production,
        machine,
        operations,
      } = resp.data;

      const SelectedItem = this.state.items.find(v => v.label.split('-')[0].trim() === piece_code)
      if (SelectedItem !== undefined)
        this.setState({ selectedItem: SelectedItem, id_item: SelectedItem.value })

      let operations_aux = operations

      let operations_portuguese = []
      operations_aux.map(e => {
        if (e.time_wait_piece_cicle === undefined) {
          delete e.time_wait_piece_cicle
        }
        delete e.id_machine
      })
      operations_aux.forEach(e => {
        operations_portuguese.push({
          "Código": e.operation,
          "Alternativa": e.alternative,
          "PPH": e.pph,
          "Nº Peça/Ciclo": e.piece_cicle,
          "Tempo de espera": e.time_wait_piece_cicle,
          "Máquina": e.machine,
          "Ação": true
        })
      })

      operations_portuguese.forEach(element => {
        if (element["Tempo de espera"] === undefined) {
          delete element["Tempo de espera"]
        }
      })

      this.setState({
        id: childData,
        code: order,
        piece_code: piece_code,
        date_op: date_created,
        piece_production: piece_production,
        operationsAllprops: operations_aux,
        operations: operations_portuguese,
        render: true
      });

      const result = this.state.machines.find((e) => e.label === machine);
      this.setState({ id_machine: result.value });
    }).catch((err) => { console.log(err) });
  };

  handleChange = (value, name) => this.setState({ [name]: value });

  delOperationNew = (code, alternative)=>{
    let operations = this.state.operationsAllprops.filter((e)=> `${e.operation}${e.alternative}` !== `${code}${alternative}`);
    this.setState({operationsAllprops: operations});
  }

  altOperation = (codeOperation, alternativeOperation, pph, piece_cicle, time_wait_piece_cicle)=>{

    let operation = this.state.operationsAllprops.findIndex((e)=>e.operation == codeOperation && e.alternative == alternativeOperation);
    let operations = this.state.operationsAllprops;
    operations[operation].pph = pph.toString().slice(-1) == "." ? parseFloat(pph.toString().slice(0,-1)) : pph;
    operations[operation].piece_cicle = piece_cicle.toString().slice(-1) == "." ? parseFloat(piece_cicle.toString().slice(0,-1)) : piece_cicle;
    operations[operation].time_wait_piece_cicle = time_wait_piece_cicle.toString().slice(-1) == "." ? parseFloat(time_wait_piece_cicle.toString().slice(0,-1)) : time_wait_piece_cicle;

    this.setState({operationsAllprops: operations});
  }


  addOperation = () => {
    this.setState({ count: this.state.count + 1 })
    let obj = {}
    if (this.state.objEdit.operation !== "" && this.state.objEdit.alternative !== "" && this.state.objEdit.pph !== "" && this.state.objEdit.pph !== "." && this.state.objEdit.piece_cicle !== "" && this.state.objEdit.piece_cicle !== "." && this.state.objEdit.time_wait_piece_cicle !== "" && this.state.objEdit.time_wait_piece_cicle !== "." && this.state.objEdit.machine !== 0 ) {

      let objOp = this.state.objEdit;
      //console.log(this.state.objEdit);
      objOp.pph = objOp.pph.toString().slice(-1) == "." ? parseFloat(objOp.pph.toString().slice(0,-1)) : objOp.pph;
      objOp.piece_cicle = objOp.piece_cicle.toString().slice(-1) == "." ? parseFloat(objOp.piece_cicle.toString().slice(0,-1)) : objOp.piece_cicle;
      objOp.time_wait_piece_cicle = objOp.time_wait_piece_cicle.toString().slice(-1) == "." ? parseFloat(objOp.time_wait_piece_cicle.toString().slice(0,-1)) : objOp.time_wait_piece_cicle;

      this.setState({objEdit: objOp});

      //console.log(objOp);

      let opAux = this.state.operationsAllprops.filter((element)=> (`${element.operation}${element.alternative}`) == (`${this.state.objEdit.operation}${this.state.objEdit.alternative}`));

      if(opAux.length > 0 && this.state.operationsAllprops.length > 0){
        this.setState({ message: "Erro ao adiconar operação! Código e alternativa já adicionados.", show: true })
      }else{
        for (let key in this.state.objEdit) {
          if (Object.hasOwnProperty.call(this.state.objEdit, key)) {
            switch (key) {
              case "operation":
                obj["Código"] = this.state.objEdit[key]
                break;
              case "alternative":
                obj["Alternativa"] = this.state.objEdit[key]
                break;
              case "pph":
                obj["PPH"] = this.state.objEdit[key].toString().slice(-1) == "." ? parseFloat(this.state.objEdit[key].toString().slice(0,-1)) : this.state.objEdit[key];
                break;
              case "piece_cicle":
                obj["Nº Peça/Ciclo"] = this.state.objEdit[key].toString().slice(-1) == "." ? parseFloat(this.state.objEdit[key].toString().slice(0,-1)) : this.state.objEdit[key];
                break;
              case "time_wait_piece_cicle":
                obj["Tempo de espera"] = this.state.objEdit[key].toString().slice(-1) == "." ? parseFloat(this.state.objEdit[key].toString().slice(0,-1)) : this.state.objEdit[key];
                break;
              case "machine":
                obj["Máquina"] = this.state.objEdit[key]
                break;
            }
          }
        }
        obj["Ação"] = true
        this.setState({ operations: [...this.state.operations, obj] }, () => {
          this.setState({ operationsAllprops: [...this.state.operationsAllprops, this.state.objEdit] }, () => {
            document.getElementsByClassName("inputsOrder")[0].reset();
            this.setState({
              objEdit: {
                operation: "", alternative: null, pph: 0, piece_cicle: 0,
                time_wait_piece_cicle: 0, machine: 0
              }, selected_MachineOp: ""
            })
          })
        })
      }

      

    } else {

      if(this.state.objEdit.time_wait_piece_cicle == "." && this.state.objEdit.piece_cicle == "." && this.state.objEdit.pph == "."){
        this.setState({ message: "Erro de validação! Os campos numéricos devem ser preenchidos corretamente.", show: true });
      }else{
        this.setState({ message: "Necessário preencher todos os campos do item.", show: true })
      }
    }
  }
  sendData = () => {this.state.piece_production.toString().slice(-1) == "." ? parseFloat(this.state.piece_production.toString().slice(0,-1)) : this.state.piece_production
    if (this.state.id !== 0) {
      console.log(this.state.operationsAllprops)
      if(this.state.operationsAllprops.length > 0){
        Api.put(`/production-orders/${this.state.id}`, {
          code: this.state.code,
          piece_code: this.state.piece_code,
          piece_production: this.state.piece_production.toString().slice(-1) == "." ? parseFloat(this.state.piece_production.toString().slice(0,-1)) : this.state.piece_production,
          operations: this.state.operationsAllprops,
          id_item: this.state.id_item,
          date_op: moment().format("DD/MM/YYYY"),
          unit: this.state.selectedUnit
        })
          .then((resp) => {

            this.setState({notification: true, notification_message: "Ordem alterada com sucesso!"});
            setTimeout(()=>{
             return window.location.reload();
            },2000)
          })
          .catch((error) => {
  
          });
      }else{
        this.setState({ message: "A ordem deve ter no mínimo 1 operação.", show: true });
      }
      
    } else {
      this.setState({ message: "Selecione uma ordem.", show: true });
    }
  };

  callbackfunction = () => {
    this.setState({ show: false });
  };


  handleMachines = (value, label) => {
    let obj = this.state.objEdit
    obj['machine'] = label
    const machineOp = this.state.machines.find((e) => e.value === value)
    this.setState({ objEdit: obj, selected_MachineOp: machineOp })
  }

  handleItem = (value, label) => {
    const SelectedItem = this.state.items.find((e) => e.value === value)
    this.setState({ selectedItem: SelectedItem, id_item: SelectedItem.value })
  }

  handleUnit = (value) => {
    const SelectedUnit = this.state.units.find((e) => e.value === value)
    this.setState({ selectedUnit: SelectedUnit})
  }



  render() {
    let { show, message, PO_code_array, items, selectedItem, selectedUnit, units, notification, notification_message, notification_type } = this.state;
    return (

        <div className="add_orders box boxaltorder" style={{flexDirection: "column"}}>
          {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
          {this.state.show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
            />
          ) : null}
          <div id="components">
          <div className="minibox miniboxOrder">
          <h4>Ordem:</h4>
                <form className="inputsOrder">
                <div className='inputOrder element'>
                  <Select
                    autoSelect={true}
                    label={"Ordens de Produção"}
                    arrData={PO_code_array}
                    handleSelect={this.selectPoCode}
                  />
                </div>
                <div className='inputOrder element'>
                  <Select
                    label={"Código da Peça"}
                    arrData={items}
                    selectedID={selectedItem}
                    isDisabled
                    handleSelect={this.handleItem}
                  />
                </div>
                <div className="inputOrder element">
                  <TextField
                    section
                    focus={false}
                    title="Qtd. de peças á produzir"
                    value={this.state.piece_production}
                    name="piece_production"
                    id={"piece_production"}
                    min={1}
                    max={6}
                    autoComplete="off"
                    parentCallback={this.handleChange}
                    decimal
                    validationType="decimal"
                  />
                </div>
              </form>
            </div>
          <div className="minibox miniboxOrder" id="operacoes">
            <h4>Operações:</h4>
              <div className="inputsOrder">
                <div className='inputOrder element'>
                  <TextField
                    section={false}
                    focus={false}
                    title="Código"
                    name={"operation"}
                    min={1}
                    max={3}
                    parentCallback={this.setOperation}
                  />
                </div>
                <div className='inputOrder element'>
                  <TextField
                    section
                    focus={false}
                    id={"alternative"}
                    title="Alternativa"
                    name={"alternative"}
                    min={1}
                    max={3}
                    parentCallback={this.setOperation}
                  />
                </div>
                <div className='inputOrder element'>
                  <TextField
                    section
                    focus={false}
                    id={"pph"}
                    title="PPH"
                    name={"pph"}
                    decimal
                    min={1}
                    max={6}
                    parentCallback={this.setOperation}
                  />
                </div>
                <div className='inputOrder element'>
                  <TextField
                    section
                    focus={false}
                    id={"piece_cicle"}
                    decimal
                    title="Nº Peça/Ciclo"
                    name={["piece_cicle"]}
                    min={1}
                    max={6}
                    parentCallback={this.setOperation}
                  />
                </div>
                <div className='inputOrder element'>
                  <TextField
                    section
                    focus={false}
                    title="Tempo de espera"
                    name={["time_wait_piece_cicle"]}
                    id={"time_wait_piece_cicle"}
                    decimal
                    min={1}
                    max={6}
                    parentCallback={this.setOperation}
                  />
                </div>
                <div className='inputOrder element'>
                  <Select
                    label="Máquina"
                    selectedID={this.state.selected_MachineOp}
                    arrData={this.state.machines}
                    handleSelect={this.handleMachines}
                    name={'machine'}
                  />
                </div>
            </div>
          </div>
          </div>
          <div className="buttons buttonsOrder">
          <div className='tf1AddItemBtn submitButton submitButtonOrder'><Button title="+ Adicionar"
                parentCallback={this.addOperation} />
              </div>
              <div className='btnAltOrder submitButton submitButtonOrder'>
              <Button title="Alterar" parentCallback={this.sendData} />
              </div>
          </div> 
          <div className="minibox miniboxOrder" id="table">
            <div className="form">
              {this.state.render ?
                <TableEditable data={this.state.operationsAllprops} del={this.delOperationNew} alt={this.altOperation}></TableEditable> : null}
            </div>
         </div>

        </div >
    );
  }
}